var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var doLog = function (level) {
    var messages = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        messages[_i - 1] = arguments[_i];
    }
    if (localStorage.getItem('DEBUG') === 'true' || window.DEBUG) {
        console[level].apply(console, __spread(messages));
    }
};
export var logger = {
    info: doLog.bind(null, 'info'),
    warn: doLog.bind(null, 'warn'),
    error: doLog.bind(null, 'error'),
    debug: doLog.bind(null, 'debug'),
    log: doLog.bind(null, 'log'),
};
//# sourceMappingURL=logger.js.map